import { HttpParams } from "@angular/common/http";
import { Component, Injectable, Input, OnInit } from "@angular/core";
import { NgForm } from "@angular/forms";
import { Router } from "@angular/router";
import "moment-duration-format";
import * as moment from "moment-timezone";
import { AuthService } from "../../../authentication/services/auth.service";
import { AlertService } from "../../../shared/alert/services/alert.service";
import { SignalBoConfiguration } from "../../../shared/configuration/SignalBoConfiguration";
import { Author } from "../../../shared/models/Author";
import { CalendarEventBO } from "../../../shared/models/calendarEventDateBO";
import { EventDateFilter } from "../../../shared/models/eventDateFilter";
import { EventFilter } from "../../../shared/models/eventFilter";
import { ScheduledType } from "../../../shared/models/ScheduledContent";
import { AuthorService } from "../../../shared/services/author.service";
import { CalendarService } from "../../../shared/services/calendar.service";
import { CalendarBOService } from "../../../shared/services/calendarBO.service";
import { EditorialImageCacheService } from "../../../shared/services/editorialImageCache.service";
import { PostI3Service } from "../../../shared/services/postI3.service";
import { ScheduleService } from "../../../shared/services/schedule.service";
import { SignalBoService } from "../../../shared/services/signalbo.service";
import { Category } from "../../models/Category";
import { EditorialMessageContent } from "../../models/EditorialMessageContent";
import { Market } from "../../models/Market";
import { Periods } from "../../models/Periods";
import { SignalI3 } from "../../models/SignalI3";
import {
  SignalMessage,
  SignalMessageActionType,
} from "../../models/SignalMessage";
import { StrategyStats } from "../../models/StrategyStats";
import { DataRelatedFactory } from "../../services/dataRelatedFactory";
import { SignalsService } from "../../services/signals.service";
import { SignalsI3Service } from "../../services/signalsI3.service";
import { ValidationsService } from "../../services/validations.service";
import { SignalsPublishScheduleModalComponent } from "./signalsPublishScheduleModal.component";
import { MatDialog } from "@angular/material";
import { userQuestionAuthorId } from "../../utils/constants";

@Component({
  selector: "app-signals-message-create-edit",
  templateUrl: "../templates/signalsMessageCreateEdit.component.html",
  styleUrls: ["../styles/signalsMessages.component.css"],
})
@Injectable()
export class SignalsMessageCreateEditComponent implements OnInit {
  @Input() isScheduled: boolean;
  @Input() title: string;
  @Input() location: string;

  private ActionType: SignalMessageActionType;
  private MessageId?: string;

  private selectedImage: any;
  private editorConfig: any;
  private inProgress: boolean = false;
  private validationError: {
    message: string;
    show: boolean;
    type: string;
  } = {
      message: "",
      show: false,
      type: "",
    };
  private relatedPostValidation: {
    success: boolean;
    loading: boolean;
    message: string;
  } = {
      success: false,
      loading: false,
      message: "",
    };
  private relatedEventValidation: {
    success: boolean;
    loading: boolean;
    data: CalendarEventBO[];
    relatedData: CalendarEventBO[];
    message: string;
  } = {
      success: false,
      loading: false,
      data: null,
      relatedData: null,
      message: null,
    };
  private unmodifiedMessage: SignalMessage;
  private message: SignalMessage;
  private Authors: Author[];
  private AuthorsDropdown: Author[];
  private Categories: string[] = [
    Category.Analysis,
    Category.Education,
    Category.Warning,
    Category.Review,
  ];
  private Markets: string[] = [
    Market.Commodities,
    Market.Cryptos,
    Market.Forex,
    Market.Stocks,
  ];
  private dialogStyle = {
    hasBackdrop: true,
    backdropClass: "fxstreet-modal-backdrop",
    panelClass: "fxstreet-message-dialog-panel",
    position: { top: "60px" },
  };

  private Periods: string[] = [Periods.DateRange, Periods.FullDataSet];
  private selectedPeriod: string;
  private Images: string[];
  private Strategies: object[];
  private selectedStrategy: any;
  private dateFrom: moment.Moment;
  private dateTo: moment.Moment;
  private strategyData: StrategyStats;
  private dateUtc: moment.Moment;
  private signalsI3: SignalI3[];

  constructor(
    private signalBoService: SignalBoService,
    private postI3Service: PostI3Service,
    private calendarBOService: CalendarBOService,
    private calendarService: CalendarService,
    private authorService: AuthorService,
    private dataRelatedFactory: DataRelatedFactory,
    private signalBoConfiguration: SignalBoConfiguration,
    private validationService: ValidationsService,
    private authService: AuthService,
    private signalService: SignalsService,
    private signalI3Service: SignalsI3Service,
    private editorialImageCacheService: EditorialImageCacheService,
    private ScheduleService: ScheduleService,
    private _alertService: AlertService,
    private router: Router,
    private _dialog: MatDialog,
  ) {
    this.message = this.createEmptyMessage();
    this.dateUtc = moment.utc();

  }

  getUrlParams() {
    const splittedLocation = window.location.hash.split("/")[3];
    const messageId = window.location.hash.split("/")[4];

    this.ActionType = splittedLocation as SignalMessageActionType;
    this.MessageId = messageId;
  }

  getMessage() {
    if (this.isScheduled) {
      this.ScheduleService.GetScheduledById(this.MessageId).subscribe(
        (message: SignalMessage) => {
          this.message = message;
          this.dateUtc = message.dateUtc;
          this.selectedImage = message.content.imageUrl;
        }
      );
    } else {
      this.signalBoService
        .GetEditorialMessageById(this.MessageId)
        .subscribe((message) => {
          this.message = message;
          this.selectedImage = this.message.content.imageUrl;
        });
    }
  }

  ngOnInit() {
    this.setEditorConfig();
    this.loadImages();
    this.loadStrategies();
    this.loadSignalsData();
    this.getUrlParams();
    if (this.MessageId) {
      this.getMessage();
    }
    this.loadAuthors(!Boolean(this.message));
  }

  async loadImages() {
    let nodes = await this.editorialImageCacheService
      .GetByPath("Videos/YouTube")
      .toPromise();
    if (nodes)
      this.Images = nodes.map(function (i) {
        return i.ThumbnailXtraSmall;
      });
  }

  loadAuthors(setDefault) {
    this.signalBoConfiguration.GetAllowedAuthors().subscribe((authors) => {
      const authorId = this.message.content.authorId;
      this.Authors = authors;
      this.AuthorsDropdown = authors.filter(function (author) {
        return author.AuthorId !== authorId;
      });
      if (setDefault)
        this.message.content.authorId = this.getSelectedAuthorId(authors);
    });
  }

  loadStrategies() {
    this.signalService.GetActiveStrategies().subscribe((strategies) => {
      this.Strategies = strategies;
    });
  }

  loadSignalsData() {
    this.signalI3Service
      .GetAll(this.authService.getActualLanguage().cultureNameISO)
      .subscribe((signals: SignalI3[]) => {
        this.signalsI3 = signals;
      });
  }

  loadStrategyData() {
    let params = new HttpParams();

    if (this.dateFrom)
      params = params.set("DateFrom", this.dateFrom.toISOString());
    if (this.dateTo) params = params.set("DateTo", this.dateTo.toISOString());

    this.signalService
      .GetStatsByStrategy(this.selectedStrategy.id, params)
      .subscribe((data) => {
        this.strategyData = data;
        this.message.content.title = this.getMessageTitle();
        this.message.content.description = this.getStrategyStatsMessage();
      });
  }

  publishSignalMessage() {
    if (!this.validateForm())
      return;

    var message = this.message

    const publishMessageDialog = this._dialog.open(SignalsPublishScheduleModalComponent, {
      ...this.dialogStyle,
      data: { message },
    });

    publishMessageDialog.componentInstance.itemPublished.subscribe((result) =>
      this.router.navigate([this.Url])
    );

    this.inProgress = false;
    this.validationError.show = false;
  }

  addTag(tag) {
    this.message.content.tags.push(tag);
  }

  removeTag(tag) {
    let indexTag = this.message.content.tags.indexOf(tag);
    if (indexTag != -1) {
      this.message.content.tags.splice(indexTag, 1);
    }
  }

  private getMessageTitle() {
    const template = `${this.selectedStrategy.name} Performance Stats`;

    return template;
  }

  private getStrategyStatsMessage() {
    const template = `<p><b>Win Rate: </b>${this.strategyData.statCalculation.winRate
      }<br>
                  <b>Net Profit: </b>${this.strategyData.statCalculation.netProfit
      }<br>
                  <b>Average Profit: </b>${this.strategyData.statCalculation.averageProfit
      }<br>
                  <b>Average Loss: </b>${this.strategyData.statCalculation.averageLoss
      }<br>
                  <b>Average Duration: </b>${moment
        .duration(
          this.strategyData.statCalculation.averageDuration,
          "minutes"
        )
        .format("d[d] h[h] m[m]")}<br>
                  <b>Trades: </b>${this.strategyData.statCalculation.numberOfTrades
      }<br></p>`;

    return template;
  }

  async onSubmit(form: NgForm) {

    if (!this.validateForm())
      return;

    const result = await this.saveMessage().catch(() => {
      this.inProgress = false;
      return false;
    });

    if (result) {
      this.inProgress = false;
      this.validationError.show = false;
      this.router.navigate([this.Url], { queryParams: { publish: true } });
    }
  }

  validateForm() {
    if (this.isScheduled)
      this.dateUtc = this.dateUtc.add(this.dateUtc.utcOffset(), "m").utc();
    if (
      !this.validateRequired() ||
      !this.validateCategory() ||
      !this.validateTags() ||
      (this.isScheduled && !this.validateScheduledDate())
    )
      return false;

    this.inProgress = true;

    return true;
  }

  handleFileChanged(imageUrl: string) {
    this.message.content.imageUrl = imageUrl;
    this.validateMediaLink();
  }
  private async saveMessage(): Promise<SignalMessage> {
    this.message.dateUtc = this.dateUtc;
    let message: SignalMessage = {
      id: this.message.id,
      dateUtc: this.message.dateUtc,
      content: this.message.content,
    };

    if (message.content.authorId) {
      message.content.authorName = this.getAuthorName(message.content.authorId);
    } else {
      message.content.authorName = undefined;
    }

    if (!message.id) {
      this._alertService.add("success", "Message created successfully.");
      if (this.isScheduled) {
        return this.ScheduleService.CreateScheduled<EditorialMessageContent>({
          type: ScheduledType.InsightMessage,
          content: message.content,
          dateUtc: message.dateUtc,
          id: message.id,
        })
          .map((scheduled) => {
            const result = {
              id: scheduled.id,
              dateUtc: scheduled.dateUtc,
              content: scheduled.content,
            };

            return result;
          })
          .toPromise();
      } else {
        return this.signalBoService.CreateMessage(message.content).toPromise();
      }
    } else {
      this._alertService.add("success", "Message edited successfully.");

      if (this.isScheduled) {
        return this.ScheduleService.EditScheduled<EditorialMessageContent>({
          type: ScheduledType.InsightMessage,
          content: message.content,
          dateUtc: message.dateUtc,
          id: message.id,
        })
          .map((scheduled) => {
            const result = {
              id: scheduled.id,
              dateUtc: scheduled.dateUtc,
              content: scheduled.content,
            };

            return result;
          })
          .toPromise();
      } else {
        return this.signalBoService.EditMessage(message).toPromise();
      }
    }
  }

  private setEditorConfig() {
    this.editorConfig = {
      height: 200,
      toolbarGroups: [
        { name: "basicstyles", groups: ["basicstyles"] },
        { name: "links", groups: ["links"] },
        { name: "paragraph", groups: ["list", "blocks"] },
        { name: "document", groups: ["mode"] },
        { name: "styles", groups: ["styles"] },
      ],
    };
  }

  private validateMediaLink() {
    this.validationError.show = false;

    const isValid = this.validationService.validateMediaLink(this.message);
    if (isValid) return;

    this.validationError.message = "With media image please provide MediaLink.";
    this.validationError.show = true;
    this.validationError.type = "warning";
  }

  private validateRequired(): boolean {
    this.validationError.show = false;

    const isRequiredValid = this.validationService.validateRequired(
      this.message
    );
    if (isRequiredValid) return true;

    this.validationError.message =
      "Please, title is required and provide at least image or description.";
    this.validationError.show = true;
    this.validationError.type = "danger";

    return false;
  }

  private validateCategory(): boolean {
    this.validationError.show = false;

    const isValidCategory = this.validationService.validateCategory(
      this.message
    );
    if (isValidCategory) return true;

    this.validationError.message =
      "With Analysis or Education ensure Author is not empty.";
    this.validationError.show = true;
    this.validationError.type = "danger";

    return false;
  }

  private validateTags(): boolean {
    this.validationError.show = false;

    const isValidTags = this.validationService.validateTags(this.message);
    if (isValidTags) return true;

    this.validationError.message =
      "Add at least one tag to the insight message.";
    this.validationError.show = true;
    this.validationError.type = "danger";

    return false;
  }

  private validateScheduledDate(): boolean {
    this.validationError.show = false;

    const isValidScheduledDate = this.validationService.validateScheduledDate(
      this.dateUtc
    );

    if (isValidScheduledDate) return true;

    this.validationError.message = "The scheduled date must be a future date.";
    this.validationError.show = true;
    this.validationError.type = "danger";

    return false;
  }

  validatePost() {
    this.resetUIValidatePost();
    var urlToValidate = this.message.content.postLink;
    if (!urlToValidate || urlToValidate === "") return;
    this.relatedPostValidation.loading = true;
    let pathName: string = "";
    let validPath: boolean = true;
    try {
      pathName = new URL(urlToValidate).pathname;
    } catch (error) {
      validPath = false;
    }
    if (!validPath) {
      this.resetUIValidatePost();
      this.relatedPostValidation.message = "Path not valid";
      return;
    }

    this.postI3Service
      .GetByUrl(pathName, this.authService.getActualLanguage().cultureNameISO)
      .subscribe((post) => {
        if (post) {
          this.authorService
            .GetAuthorMiniById(post.authorId)
            .subscribe((author) => {
              if (author) {
                const strategy = this.dataRelatedFactory.buildStrategy(
                  post.contentType
                );
                this.message.content = strategy.build(
                  post,
                  this.message.content,
                  author
                );
                this.relatedPostValidation.loading = false;
                this.relatedPostValidation.success = true;
              } else {
                this.relatedPostValidation.loading = false;
                this.relatedPostValidation.success = false;
                this.relatedPostValidation.message = "Related post not found.";
              }
            });
        } else {
          this.relatedPostValidation.loading = false;
          this.relatedPostValidation.success = false;
          this.relatedPostValidation.message = "Related post not found.";
        }
      });
  }

  validateCalendarEvent() {
    var eventToValidate = this.message.content.eventTitle;
    if (!eventToValidate) return;

    let startingDate = new Date();
    startingDate.setMonth(startingDate.getMonth() - 1);
    let endingDate = new Date();
    endingDate.setMonth(endingDate.getMonth() + 1);

    let eventFilter: EventFilter = {
      StartUtc: startingDate,
      EndUtc: endingDate,
      Name: eventToValidate,
    };
    this.relatedEventValidation.loading = true;
    this.calendarBOService.FindEvent(eventFilter).subscribe((eventList) => {
      if (eventList.length > 0) {
        this.relatedEventValidation.loading = false;
        this.relatedEventValidation.data = eventList;
        this.relatedEventValidation.relatedData = null;
        this.relatedEventValidation.message = null;
      } else {
        this.relatedEventValidation.loading = false;
        this.relatedEventValidation.data = null;
        this.relatedEventValidation.relatedData = null;
        this.relatedEventValidation.message = "Calendar event not found.";
      }
    });
  }

  showEventDates(eventId: string) {
    if (!eventId) return;

    this.relatedEventValidation.data = null;

    let startingDate = new Date();
    startingDate.setMonth(startingDate.getMonth() - 2);
    let endingDate = new Date();
    endingDate.setMonth(endingDate.getMonth() + 2);

    let eventDateFilter: EventDateFilter = {
      EventId: eventId,
      StartUtc: startingDate,
      EndUtc: endingDate,
    };
    this.calendarBOService
      .FindEventDate(eventDateFilter)
      .subscribe((eventDateList) => {
        if (eventDateList) {
          this.relatedEventValidation.loading = false;
          this.relatedEventValidation.relatedData = eventDateList;
          this.relatedEventValidation.message = null;
        } else {
          this.relatedEventValidation.loading = false;
          this.relatedEventValidation.relatedData = null;
          this.relatedEventValidation.message =
            "Calendar event date not found.";
        }
      });
  }

  addRelatedEvent(eventDateId: string) {
    if (!eventDateId) return;

    this.calendarService
      .getEventDateById(eventDateId, "en")
      .subscribe((eventDate) => {
        if (eventDate) {
          const strategy = this.dataRelatedFactory.buildStrategy("calendar");
          this.message.content = strategy.build(
            eventDate,
            this.message.content,
            null
          );
          this.relatedEventValidation.loading = false;
          this.relatedEventValidation.success = true;
          this.relatedEventValidation.relatedData = null;
          this.message.content.eventTitle = eventDate.name;
        }
      });
  }

  resetUIValidatePost() {
    this.relatedPostValidation.success = false;
    this.relatedPostValidation.loading = false;
  }

  deleteRelatedPost() {
    this.relatedPostValidation.loading = false;
    this.relatedPostValidation.success = false;
    this.relatedPostValidation.message = "";
    this.message.content.postLink = "";
    this.message.content.relatedPostContent = null;
    this.message.content.relatedWebinarContent = null;
    this.message.content.relatedRecordingContent = null;
    this.message.content.relatedTradeContent = null;
  }

  onSignalsChange = (e: any) => {
    const value = e.target.value;
    if (value === undefined) return;

    if (value === "") {
      this.deleteRelatedSignal();
      return;
    }

    let positionId = value;
    if (positionId.includes("|")) positionId = value.split("|")[0];

    const signal = this.signalsI3.find(
      (x) => x.positionMaintenanceId === positionId.trim()
    );

    if (signal === undefined) return;

    const strategy = this.dataRelatedFactory.buildStrategy("signal");
    this.message.content = strategy.build(signal, this.message.content);
    this.message.content["signalValue"] = value;
  };

  deleteRelatedSignal = () => {
    this.message.content.relatedSignalContent = null;
    this.message.content.signalValue = "";
  };

  deleteRelatedEvent() {
    this.relatedEventValidation.loading = false;
    this.relatedEventValidation.success = false;
    this.relatedEventValidation.message = "";
    this.message.content.eventTitle = "";
    this.message.content.relatedCalendarContent = null;
  }

  private createEmptyMessage() {
    let message: SignalMessage = {
      id: "",
      dateUtc: "",
      content: {
        title: "",
        imageUrl: "",
        description: "",
        link: "",
        mediaLink: "",
        authorId: "",
        category: Category.Analysis,
        tags: [],
        market: Market.Forex.toLowerCase(),
        postLink: "",
        eventTitle: "",
        signalValue: "",
        relatedPostContent: "",
        relatedSignalContent: "",
      },
    };

    return message;
  }

  private getSelectedAuthorId(authors) {
    let userId = this.authService.getUserId();
    let author = authors.find(function (author) {
      return author.UserId == userId;
    });
    return author != undefined ? author.AuthorId : "";
  }

  private getAuthorName(authorId) {
    let author = this.Authors.find((author) => author.AuthorId === authorId);
    return author.Name;
  }

  private isScheduledUserQuestion() {
    if(!this.message || !this.message.content) return false;

    var date = new moment().utc();

    return this.message.dateUtc && this.message.dateUtc.isAfter(date) 
    && this.message.content.authorId == userQuestionAuthorId;
  }

  public get Title() {
    const prefix =
      this.ActionType === SignalMessageActionType.CREATE ? "Create" : "Edit";
    return `${prefix} ${this.title}`;
  }

  public get Url() {
    var url = `/tradingstudio/${this.location}`;

    if(this.isScheduledUserQuestion()) 
         url = `/tradingstudio/user-question`;
    return url;
  }
}



// WEBPACK FOOTER //
// ./src/app/tradingstudio/components/scripts/signalsMessageCreateEdit.component.ts